import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, Settings, ScrollText, LogOut, ShieldCheck, Users, History, BookOpen, Bell, Search, BarChart3 } from "lucide-react";

const LINKS = [
  { to: "/admin", label: "Solicitudes", icon: LayoutDashboard, end: true },
  { to: "/admin/estadisticas", label: "Estadísticas", icon: BarChart3 },
  { to: "/admin/recordatorios", label: "Recordatorios", icon: Bell },
  { to: "/admin/buscar-familia", label: "Buscar familia", icon: Search },
  { to: "/admin/registrados", label: "Registrados", icon: Users },
  { to: "/admin/historial", label: "Historial becas", icon: History },
  { to: "/admin/config", label: "Configuración", icon: Settings },
  { to: "/admin/auditoria", label: "Auditoría", icon: ScrollText },
  { to: "/manual", label: "Manuales", icon: BookOpen },
];

export default function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <header className="bg-primary text-white sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-5 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <ShieldCheck className="w-6 h-6 text-accent" />
            <span className="font-heading font-extrabold text-lg">EIM Becas · Administración</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="hidden sm:block text-sm text-white/70">{user?.name}</span>
            <Button variant="ghost" size="sm" className="text-white hover:bg-white/10" onClick={() => { logout(); navigate("/"); }} data-testid="admin-logout">
              <LogOut className="w-4 h-4" />
            </Button>
          </div>
        </div>
        <nav className="max-w-7xl mx-auto px-5 flex gap-1 overflow-x-auto">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end}
              className={({ isActive }) => `flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 whitespace-nowrap ${isActive ? "border-accent text-white" : "border-transparent text-white/60 hover:text-white"}`}
              data-testid={`nav-${l.label}`}>
              <l.icon className="w-4 h-4" /> {l.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="max-w-7xl mx-auto px-5 py-8 fade-in">{children}</main>
    </div>
  );
}
